/**
 * 타입 안전 유틸리티 함수
 */

/**
 * Object.keys의 타입 안전 버전
 *
 * 기본 Object.keys()는 string[]을 반환하지만,
 * 이 함수는 객체의 실제 키 타입을 유지합니다.
 *
 * @example
 * const obj = { ko: '한국어', en: 'English', ja: '日本語' } as const;
 * const keys = objectKeys(obj); // ('ko' | 'en' | 'ja')[]
 */
export function objectKeys<T extends object>(obj: T): Array<keyof T & string> {
  return Object.keys(obj) as Array<keyof T & string>;
}
